document.addEventListener("DOMContentLoaded", function() {
  var daysAfterToday = 4;
  var today = new Date();
  var shipDate = new Date(today.setDate(today.getDate() + daysAfterToday));
  var options = { weekday: 'short', month: 'long', day: 'numeric' };
  var formattedDate = shipDate.toLocaleDateString(document.documentElement.lang || 'en-US', options);
  const allDates = document.getElementsByClassName("custom-shipping-date");
  for (let i = 0; i < allDates.length; i++) {
    allDates[i].textContent = formattedDate;
  }
});
